import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useNavigate } from '@tanstack/react-router';
import { App } from 'antd';
import { useCallback } from 'react';

import { MutationCallbackOptions } from '@lib/api/options/types';
import { getRateLimitMessage } from '@lib/utils/error-handler';
import { ROUTE_PATHS } from '@modules/route-paths';

import { logoutOptions } from '../../options/auth';

export const useLogout = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const { mutateAsync: logout, isPending: logingOut } =
    useMutation(logoutOptions());

  const handleOnLogout = useCallback(
    (options?: MutationCallbackOptions) =>
      logout(undefined, {
        onSuccess: () => {
          queryClient.clear();

          navigate({ to: ROUTE_PATHS.LOGIN }).catch(() => undefined);

          options?.onCompleted?.();
        },
        onError: (error) => {
          message.error(
            getRateLimitMessage(error) ??
              'Não foi possível encerrar sua sessão. Tente novamente.',
          );
          options?.onError?.(error);
        },
      }),
    [logout, queryClient, navigate, message],
  );

  return { logout: handleOnLogout, logingOut };
};
